import { render } from "./CuentaBanco.vue?vue&type=template&id=13df0e5c"
import script from "./CuentaBanco.vue?vue&type=script&lang=js"
export * from "./CuentaBanco.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__